import { colors, roleColors } from "../../ui/colors";

import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import BusinessIcon from "@mui/icons-material/Business";
import BuildIcon from "@mui/icons-material/Build";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import WindowIcon from "@mui/icons-material/Window";
import WeekendIcon from "@mui/icons-material/Weekend";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import LayersIcon from "@mui/icons-material/Layers";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ConstructionIcon from "@mui/icons-material/Construction";

export const renderIconCommercial = (name = "", active = false) => {
  const color = active ? roleColors.commercial.base : colors.gray[400];
  const n = name.toLowerCase();

  // General services
  if (n.includes("janitorial")) return <CleaningServicesIcon sx={{ color }} />;
  if (n.includes("custodial")) return <BuildIcon sx={{ color }} />;
  if (n.includes("office")) return <BusinessIcon sx={{ color }} />;
  if (n.includes("restaurant")) return <RestaurantIcon sx={{ color }} />;
  if (n.includes("deep")) return <AutoAwesomeIcon sx={{ color }} />;

  // Windows
  if (n.includes("window")) return <WindowIcon sx={{ color }} />;

  // Upholstery
  if (n.includes("upholstery")) return <WeekendIcon sx={{ color }} />;

  // Carpets
  if (n.includes("carpet") && n.includes("dry")) return <LocalLaundryServiceIcon sx={{ color }} />;
  if (n.includes("carpet") && n.includes("steam")) return <WaterDropIcon sx={{ color }} />;
  if (n.includes("carpet") && n.includes("shampoo")) return <CleaningServicesIcon sx={{ color }} />;

  // Floors
  if (n.includes("floor") && n.includes("polish")) return <AutoAwesomeIcon sx={{ color }} />;
  if (n.includes("floor") && n.includes("buff")) return <LayersIcon sx={{ color }} />;
  if (n.includes("floor") && n.includes("scrub")) return <CleaningServicesIcon sx={{ color }} />;
  if (n.includes("floor") && (n.includes("strip") || n.includes("wax"))) return <LayersIcon sx={{ color }} />;

  // Construction / Power wash
  if (n.includes("construction")) return <ConstructionIcon sx={{ color }} />;
  if (n.includes("pressure") || n.includes("wash")) return <WaterDropIcon sx={{ color }} />;

  // Fallback
  return <CleaningServicesIcon sx={{ color }} />;
};
